"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transactionTypes = exports.pointsReservationDays = exports.pointsMinCcv = void 0;
const keys_1 = require("root/src/shared/constants/keys");
exports.pointsMinCcv = 50;
exports.pointsReservationDays = 5;
exports.transactionTypes = [
    keys_1.pointsAwardKey,
    keys_1.paypalPointsPayoutPendingKey,
    keys_1.paypalPointsPayoutDoneKey,
    keys_1.adminPointsModificationKey,
    keys_1.paidOffPlatformKey,
];
